import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Select,
  message,
  Typography,
  Input,
} from "antd";
import dataService from "../../networks/api/service/dataService";
import { useParams } from "react-router-dom";
import GreivanceTable from "../../components/GreivanceTable";

function CommonGrievance() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(true);
  const { status } = useParams();
  // Fetch grievance list
  const getGrievanceList = async () => {
  try {
    const apiStatus = status === "ASSIGNED" ? "ALL" : status;
    const response = await dataService.getGrievanceByStatus(apiStatus);
    
    if (response.code === 200) {
      let data = response.data;

      if (status === "ASSIGNED") {
        data = data.filter((g) => g.isAssigned === true); // ✅ filter assigned
      }

      setGrievances(data);
    } else {
      message.error("Failed to fetch grievances");
    }
  } catch (error) {
    message.error("Error fetching grievances");
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  getGrievanceList();
}, [status]); // ✅ also add status as dependency so it re-fetches on navigation change

  useEffect(() => {
    getGrievanceList();
  }, []);

  const getNewGrievanceList = () => {
    getGrievanceList();
  };

  return (
    <div style={{ padding: "2rem" }}>
      <GreivanceTable
        grievances={grievances}
        getNewGrievanceList={getNewGrievanceList}
        loading={loading}
      />
    </div>
  );
}

export default CommonGrievance;
